(() => {
  if (window.__mooniMobilePolishLoaded) return;
  window.__mooniMobilePolishLoaded = true;

  const MOBILE = window.matchMedia("(max-width: 749px)");

  function fixOverflow() {
    if (!MOBILE.matches) return;

    document.documentElement.style.overflowX = "hidden";
    document.body.style.overflowX = "hidden";

    document.querySelectorAll("*").forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.right > window.innerWidth + 1) {
        el.style.maxWidth = "100%";
        el.style.boxSizing = "border-box";
      }
    });
  }

  function polishText() {
    if (!MOBILE.matches) return;

    document.querySelectorAll("rte-formatter, .rte, .rich-text, .text-block").forEach((el) => {
      el.style.maxWidth = "38ch";
      el.style.marginInline = "auto";
      el.style.textAlign = "center";
      el.style.fontSize = "0.95rem";
      el.style.lineHeight = "1.6";
      el.style.wordBreak = "break-word";
      el.style.hyphens = "auto";
    });
  }

  function tightenSections() {
    if (!MOBILE.matches) return;

    document.querySelectorAll("[data-testid='section-content'], .section, .section-content-wrapper").forEach((el) => {
      el.style.paddingInline = "16px";
    });
  }

  function collapseLongCopy() {
    if (!MOBILE.matches) return;

    document.querySelectorAll("rte-formatter").forEach((block) => {
      if (block.dataset.accordionized === "true") return;

      const text = block.innerText.trim();
      if (text.length < 280) return;

      block.style.maxHeight = "12em";
      block.style.overflow = "hidden";
      block.style.position = "relative";

      const btn = document.createElement("button");
      btn.textContent = "Read more";
      btn.style.marginTop = "12px";
      btn.style.background = "none";
      btn.style.border = "none";
      btn.style.color = "#FF846A";
      btn.style.fontWeight = "600";
      btn.style.cursor = "pointer";

      let open = false;
      btn.addEventListener("click", () => {
        open = !open;
        block.style.maxHeight = open ? "none" : "12em";
        btn.textContent = open ? "Show less" : "Read more";
      });

      block.after(btn);
      block.dataset.accordionized = "true";
    });
  }

  function polishMobile() {
    fixOverflow();
    polishText();
    tightenSections();
    collapseLongCopy();
  }

  function boot() {
    polishMobile();

    document.addEventListener("shopify:section:load", polishMobile);
    document.addEventListener("shopify:section:select", polishMobile);

    const mo = new MutationObserver(() => polishMobile());
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
